import React from "react";
import LaddaButton, { ZOOM_IN } from "react-ladda-button";
import classNames from "classnames";
export default class MealBuilderActions extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.planDetailsRef = React.createRef();
        this.selectedMealsStats = () => `${this.getSelectedMealsInPlan()}/${this.getTotalMealsInPlan()}`;
        this.updateFooter = () => {
            var _a;
            var height = (_a = this.planDetailsRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight;
            if (height)
                document.documentElement.style.setProperty(`--plan-details-height`, (height - 60) + "px");
        };
    }
    render() {
        const { actionLabel, onSubmit, isLoading, plan } = this.props;
        return (React.createElement("div", { className: "plan-details", ref: this.planDetailsRef },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col col-lg-12" },
                    React.createElement("h4", null,
                        plan.name,
                        React.createElement("small", null,
                            "(",
                            plan.variant,
                            ")"))),
                React.createElement("div", { className: "col-auto col-lg-12" },
                    React.createElement("h5", null,
                        "Price: $",
                        plan.price.toFixed(2)))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-sm col-lg-12" },
                    React.createElement("div", { className: classNames("meals-selected mb-3 mb-sm-0", {
                            "meals-full": this.getSelectedMealsInPlan() == this.getTotalMealsInPlan()
                        }) },
                        "Meals selected: ",
                        React.createElement("span", { className: "badge bg-secondary text-light" }, this.selectedMealsStats()))),
                React.createElement("div", { className: "col-sm col-lg-12" },
                    React.createElement("div", { className: "plan-total" },
                        React.createElement("div", null,
                            React.createElement(LaddaButton, { type: "submit", className: "btn btn-lg btn-cta mt-lg-3", loading: isLoading, "data-style": ZOOM_IN, onClick: (e) => onSubmit(e) }, actionLabel)))))));
    }
    componentDidMount() {
        this.updateFooter();
        window.addEventListener("resize", this.updateFooter);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateFooter);
    }
    getSelectedMealsInPlan() {
        return this.props.meals.flat().filter(t => t.variant_id !== null).length;
    }
    getTotalMealsInPlan() {
        return this.props.meals.reduce((previous, day) => previous + day.length, 0);
    }
}
